<section>
    <div><app-header></app-header></div>
<div class="masterFrame">
    <div class="goBack">
        <div class="arrowBack"><img src="assets/icon/detail/back.png"></div>
        <div class="back">
            <a href="#projects" 
                onmouseover="this.style.color='#F87A55'" 
                onmouseout="this.style.color='black'">
                {{ 'detail.goback' | translate }}
            </a>
        </div>
    </div>
    <div class="detailFrame">
        @if (projects.length > 0)
        {
            <div class="detailFrameLeft">
                <div class="headline"><p>{{ projects[currentIndex].name }}</p></div>
                <div class="blueLine"><img src="assets/icon/detail/blueLine.png"></div>
                <div class="description"><p>{{ 'detail.description' | translate }}</p></div>
                <div class="desText"><p>{{ projects[currentIndex].descriptionKey | translate }}</p></div>
                <div class="impDetails"><p>{{ 'detail.detailheadline' | translate }}</p></div>
                <div class="desText"><p>{{ projects[currentIndex].implementationDetailsKey | translate }}</p></div>
                <div class="duration">
                    <p><b>{{ 'detail.duration' | translate }}</b> {{ projects[currentIndex].duration }}</p>
                </div>
                <div class="iconsDuration">
                    @for (icon of projects[currentIndex].icons; track icon.name)
                    {
                        <div class="icons">
                            <img [src]="icon.icon" alt="{{icon.name}}">{{icon.name}}
                        </div>
                    }
                </div>
            </div>
            <div class="detailFrameRight">
                <div class="imageLogoFrame">
                    <img class="projectImage" [src]="projects[currentIndex].image">
                    <div class="logo">
                        <svg viewBox="0 0 200 200" class="circle-text">
                            <defs>
                                <path id="circlePath" d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"></path>
                            </defs>
                            <text>
                                <textPath xlink:href="#circlePath" startOffset="50%">
                                    {{ projects[currentIndex].logo }}
                                </textPath>
                            </text>
                        </svg>
                        <img src="assets/icon/detail/yellowSticker.png" alt="Logo Sticker">
                        <img class="logoImage"
                             [src]="projects[currentIndex].logoImage" alt="logo"
                             onmouseover="this.src='assets/logo/logo_ms_en.png'"
                             onmouseout="this.src='assets/logo/logo_ms_en_over.png'">
                    </div>
                    <div class="buttonFrame">
                        <button class="gitandLiveBtn">
                            <a class="nav-text" [href]="projects[currentIndex].gitHub">GitHub</a>
                        </button>
                        <button class="gitandLiveBtn">
                            <a class="nav-text" [href]="projects[currentIndex].liveTest">Live Test</a>
                        </button>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="goNext">
        <div class="next">
            <button class="nav-text" (click)="nextProject()">{{ 'detail.next' | translate }}</button>
        </div>
        <div class="arrowNext"><img src="assets/icon/detail/next.png"></div>
    </div>
</div>
</section>


